<template>
    <crud-delete
        :open="open"
        :loading="loading"
        title="Eliminar Vendedor"
        :errorMessage="errorMessage"
        @delete="deleteItem"
        @close="$emit('close')"
    >
        <v-card-text>
            <vendedor-show-data :item="item" />
        </v-card-text>
        <v-card-text>
            <v-row justify="center">
                <span class="title">¿Está seguro que desea eliminar este vendedor?</span>
            </v-row>
        </v-card-text>
    </crud-delete>
</template>

<script>
import VendedorProvider from "../../../providers/VendedorProvider";
import VendedorShowData from "../VendedorShow/VendedorShowData.vue";
import { CrudDelete } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";

export default {
    name: "VendedorDelete",
    components: { VendedorShowData, CrudDelete },
    props: {
        open: { type: Boolean, default: true },
        item: { type: Object, required: true },
    },
    data() {
        return {
            errorMessage: "",
            loading: false,
        };
    },
    methods: {
        deleteItem() {
            this.loading = true;
            VendedorProvider.deleteVendedor(this.item.id)
                .then((result) => {
                    if (result.data.vendedorDelete.success) {
                        this.$emit("itemDeleted", result.data.vendedorDelete);
                        this.$emit("close");
                    } else {
                        this.errorMessage = "Error al eliminar el vendedor";
                    }
                })
                .catch((error) => {
                    let clientError = new ClientError(error);
                    this.errorMessage = clientError.i18nMessage;
                })
                .finally(() => (this.loading = false));
        },
    },
};
</script>
